export default __webpack_public_path__ + "static/media/log.1fbdc55e.png";